export default __webpack_public_path__ + "static/media/thumbnail.164c02ee.png";